import React from 'react';
import { Box } from '@mui/material';
import ManifiestoDetalleCliente from '../../components/cliente/ManifestClientDetail'

const ViajesClienteDetailPage = () => {
  return (
    <Box sx={{ p: 2 }}>
      <ManifiestoDetalleCliente
        onReorder={(newOrder) => {
          console.log('Nuevo orden de manifiesto cliente detalle:', newOrder);
        }}
      />
    </Box>
  );
};

export default ViajesClienteDetailPage;